import React, { useState } from 'react';
import { Layers } from 'lucide-react';

const FlashcardsRenderer = ({ block, isMobile }) => {
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: '1rem'
      }}>
        {block.cards && block.cards.map((card, i) => (
          <div
            key={i}
            style={{
              background: hoveredCard === i ? '#000000' : '#FFFFFF',
              borderRadius: '0.75rem',
              boxShadow: hoveredCard === i ? '0 8px 24px rgba(0, 0, 0, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
              padding: isMobile ? '1.25rem' : '1.5rem',
              border: '2px solid #000000',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              cursor: 'pointer',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              setHoveredCard(i);
              e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)';
            }}
            onMouseLeave={(e) => {
              setHoveredCard(null);
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
            }}
          >
            {/* Blue accent line */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: '#3A86FF'
            }} />

            {/* Card topic */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              marginBottom: '1rem',
              marginTop: '0.5rem'
            }}>
              <div style={{
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                background: hoveredCard === i ? '#3A86FF' : '#000000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease',
                transform: hoveredCard === i ? 'rotate(12deg)' : 'rotate(0deg)'
              }}>
                <Layers style={{
                  width: '14px',
                  height: '14px',
                  color: hoveredCard === i ? '#000000' : '#3A86FF'
                }} />
              </div>
              <h5 style={{
                fontWeight: '700',
                color: hoveredCard === i ? '#FFFFFF' : '#000000',
                fontSize: isMobile ? '0.95rem' : '1rem',
                margin: 0,
                transition: 'color 0.3s ease'
              }}>
                {card.topic}
              </h5>
            </div>

            {/* Keywords as tags */}
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '0.5rem'
            }}>
              {card.keywords && card.keywords.map((keyword, j) => (
                <span
                  key={j}
                  style={{
                    fontSize: isMobile ? '0.8rem' : '0.85rem',
                    background: hoveredCard === i ? '#FFFFFF' : '#000000',
                    color: hoveredCard === i ? '#000000' : '#FFFFFF',
                    padding: '0.375rem 0.875rem',
                    borderRadius: '9999px',
                    fontWeight: '600',
                    whiteSpace: 'nowrap',
                    transition: 'all 0.3s ease',
                    border: hoveredCard === i ? '1px solid #E5E7EB' : 'none'
                  }}
                >
                  {keyword}
                </span>
              ))}
            </div>

            {/* Decorative dot */}
            {hoveredCard === i && (
              <div style={{
                position: 'absolute',
                bottom: '12px',
                right: '12px',
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background: '#3A86FF',
                animation: 'pulse 1.5s ease-in-out infinite'
              }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FlashcardsRenderer;